import {
  REQUEST as req,
  RESPONSE as res,
  FAILURE as fail,
  CLEAR as clr,
  MARKETPLACE_CONFLICT as mktConflict,
  MARKETPLACE_CONFLICT_CLEAR as mktConflictClear,
} from '../../actions/signals/deleteBulk';

const initialState = {
  // { deleted: [...], skipped_marketplace: [...], keys, at } on success.
  response: null,
  isLoading: false,
  error: null,
  // 409 batch conflict: { keys, kind, message, active_subscribers, listings }.
  marketplaceConflict: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case req:
      return { ...state, isLoading: true, error: null };
    case res:
      return { ...state, isLoading: false, response: action.payload };
    case fail:
      return { ...state, isLoading: false, error: action.payload };
    case clr:
      return initialState;
    case mktConflict:
      return { ...state, marketplaceConflict: action.payload };
    case mktConflictClear:
      return { ...state, marketplaceConflict: null };
    default:
      return state;
  }
};
